'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const Formatters=require('../../../dist-es6/client/formatters');let

TimeFormattingService=class TimeFormattingService extends BaseService{
constructor(displaySettingsService,timeZoneService,dateService){
super();
this._displaySettingsService=displaySettingsService;
this._timeZoneService=timeZoneService;
this._dateService=dateService;

this._abbreviatedLocalTimeZone=this.timezoneInLocale(this._dateService.now(),this.localTimeZone);
}

get safeUse24HourTimelineSetting(){
return _.get(this._displaySettingsService,'use24HourTimeline',!1);
}

get localTimeZone(){
return this._timeZoneService.localTimeZone;
}

get abbreviatedLocalTimeZone(){
return this._abbreviatedLocalTimeZone;
}

timeInLocale(time,timezone,displayTimeZone=!0){
return Formatters.timeInLocale(time,timezone,displayTimeZone,this.safeUse24HourTimelineSetting);
}

timezoneInLocale(time,timezone=this.localTimeZone){
return Formatters.timezoneInLocale(time,timezone);
}

dayOfWeekInLocale(time,timezone=this.localTimeZone){
return Formatters.formatInLocale(time,'ddd',timezone,{displayTimeZone:!1});
}

dayOfWeekAndTimeInLocale(time,timezone=this.localTimeZone,displayTimeZone=!0){
const dayOfWeekString=this.dayOfWeekInLocale(time,timezone);
return dayOfWeekString+' '+this.timeInLocale(time,timezone,displayTimeZone);
}

monthDayYearAndTimeWithZone(time,timezone=this.localTimeZone,displayTimeZone){
const monthDayYear=this.monthDayYearInTimeZone(time,timezone,{displayTimeZone:!1});

return monthDayYear+' '+this.timeInLocale(time,timezone,displayTimeZone);
}

monthDayYearInTimeZone(time,timezone=this.localTimeZone,options){
return Formatters.formatInLocale(time,'MMM DD, YYYY',timezone,options);
}

timeAndFullDateInTimezone(time,timezone){
return Formatters.timeAndFullDateInTimeZone(time,timezone,this.safeUse24HourTimelineSetting);
}

timeAndFullDateInLocalTime(time){
return Formatters.timeAndFullDateInTimeZone(time,this.localTimeZone,this.safeUse24HourTimelineSetting);
}};


module.exports=TimeFormattingService;
//# sourceMappingURL=timeFormattingService.js.map
